// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3z5ZI","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3mRx8"};